import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user:
    typeof window !== 'undefined' && localStorage.getItem('userData')
      ? JSON.parse(localStorage.getItem('userData'))
      : null,
  token:
    typeof window !== 'undefined' && localStorage.getItem('userToken')
      ? localStorage.getItem('userToken')
      : '',
  rolesWithPermissions:
    typeof window !== 'undefined' &&
    localStorage.getItem('rolesWithPermissions')
      ? JSON.parse(localStorage.getItem('rolesWithPermissions'))
      : null,
  userPermissionsKeys:
    typeof window !== 'undefined' && localStorage.getItem('userPermissionsKeys')
      ? JSON.parse(localStorage.getItem('userPermissionsKeys'))
      : [],
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.user = action.payload
      localStorage.setItem('userData', JSON.stringify(action.payload))
    },
    setToken: (state, action) => {
      state.token = action.payload
      localStorage.setItem('userToken', action.payload)
    },
    logout: (state) => {
      localStorage.removeItem('userData')
      localStorage.removeItem('userToken')
      localStorage.removeItem('rolesWithPermissions')
      localStorage.removeItem('userPermissionsKeys')
      state.token = ''
      state.user = null
      state.rolesWithPermissions = null
      state.userPermissionsKeys = []
    },
    setFirstTimeLogin: (state, action) => {
      state.firstTime = action.payload
    },
    setRolesWithPermissions: (state, action) => {
      state.rolesWithPermissions = action.payload
      localStorage.setItem(
        'rolesWithPermissions',
        JSON.stringify(action.payload)
      )
    },
    setuserPermissionsKeys: (state, action) => {
      state.userPermissionsKeys = action.payload
      localStorage.setItem(
        'userPermissionsKeys',
        JSON.stringify(action.payload)
      )
    },
  },
})

export const {
  setToken,
  setUserData,
  setRolesWithPermissions,
  setuserPermissionsKeys,
  logout,
  setFirstTimeLogin,
} = authSlice.actions

export default authSlice.reducer
